import {Stack, styled} from '@mui/material';

export const TourCardContent = styled(Stack)(() => ({
  flex: 1,
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  textAlign: 'left',
}));
